
define('require-css/css!js-css/monthwidget',[],function(){});
